import { type IGamificationInfo } from '@/templates/WebCheckoutMercadoPago/@interfaces';
import { axiosInstance } from './axiosInstance';

export interface IApplyGamificationPurchaseInput {
  profileId: string | number;
  userState: string;
  bundleNameId: string;
  transactionId: string;
  origin?: string;
  bundleId?: string | number;
  partnerType?: 'iugu' | 'pagar_me' | 'starkbank';
}

export async function applyGamificationPurchase(
  input: IApplyGamificationPurchaseInput
): Promise<IGamificationInfo | null> {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_API_PRO}/gamification`,
      headers: { 'Content-Type': 'application/json' },
      data: {
        profileId: input.profileId,
        purchaseId: input.transactionId,
        userState: input.userState,
        bundleNameId: input.bundleNameId,
      },
    });

    return {
      ...data.next,
      eligible: data.eligible,
    };
  } catch (error: any) {
    if (typeof window !== 'undefined' && window?.newrelic) {
      window.newrelic.noticeError(error, {
        step: 'gamification_purchase_error',
        bundle_id: input.bundleId,
        origin: input.origin,
        status: error?.response?.status,
        message: error?.response?.data?.clientMessage || error?.message,
        partner_type: input.partnerType,
        profileId: input.profileId,
      });
    }
    return null;
  }
}
